import { z } from 'zod';

// shouldn't be nullable
const FeatureImageSchema = z
  .object({
    id: z.string(),
    alt: z.string().nullable(),
    url: z.string().url(),
  })
  .nullable();

const CategoriesSchema = z.object({
  title: z.string(),
  slug: z.string(),
  id: z.string(),
});

const DataSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  feature_image: FeatureImageSchema,
  date: z.string().datetime(),
  excerpt: z.string(),
  categories: z.array(CategoriesSchema),
});

export type BlogPageDataResponse = z.infer<typeof DataSchema>;

const MetaSchema = z.object({
  total: z.number(),
  current_page: z.number(),
  to: z.number().nullable(),
});

export const CMSBlogPageSchema = z.object({
  data: z.array(DataSchema),
  meta: MetaSchema,
});

export type CMSBlogPageResponse = z.infer<typeof CMSBlogPageSchema>;
